import { PetCareExperienceOptions } from './PetCareProfileTypes'; // Ensure PetCareExperience is an enum or object
export interface SelectOption {
  value: string;
  display: string;
}

export interface CheckboxOption {
  value: string;
  label: string;
}

export const EDUCATION_LEVELS = [
  'Some High School',
  'High School Degree',
  'Some College',
  'College Degree',
  'Some Graduate School',
  'Graduate Degree',
];

export interface EducationFormState {
  levelOfEducation: string;
  schoolName: string;
  currentlyAttending: boolean;
  major: string;
  yearGraduated: number | null;
}

export const educationLevelOptions = (): SelectOption[] =>
  EDUCATION_LEVELS.map((level) => ({
    value: level.replace(/\s+/g, '_').toUpperCase(),
    display: level,
  }));

export const graduationYearOptions = (): SelectOption[] => {
  const currentYear = new Date().getFullYear();
  return Array.from({ length: 60 }, (_, index) => {
    const year = String(currentYear - index);
    return { value: year, display: year };
  });
};

export const distanceOptions = (): SelectOption[] =>
  [1, 2, 5, 10, 15, 25, 40, 50].map((miles) => ({
    value: String(miles),
    display: `${miles} miles`,
  }));

// ---------------------------------------------------------------------------
// Detailed availability windows shared by Companion Care + Housekeeping detailed
// schedules.
// ---------------------------------------------------------------------------
export const DETAILED_AVAILABILITY_OPTIONS: CheckboxOption[] = [
  { value: 'WEEKDAY_MORNINGS', label: 'Weekday Early Morning' },
  { value: 'WEEKDAY_DAYS', label: 'Day-time Weekdays (M - F)' },
  { value: 'WEEKDAY_AFTERNOONS', label: 'Weekday Afternoons' },
  { value: 'WEEKDAY_EVENINGS', label: 'Weekday Evenings' },
  { value: 'WEEKEND_DAYS', label: 'Weekends Daytime' },
  { value: 'WEEKEND_EVENINGS', label: 'Weekends Evenings' },
];

export const TYPICAL_AVAILABILITY_OPTIONS: CheckboxOption[] = [
  { value: 'OPEN', label: 'Open (all day, everyday)' },
  { value: 'WEEKDAYS', label: 'Open Availability on Weekdays (M-F)' },
  { value: 'OTHER', label: 'Other' },
];

// ---------------------------------------------------------------------------
// Housekeeping
// ---------------------------------------------------------------------------

export const HOUSEKEEPING_TYPES_OF_SERVICES_OPTIONS: CheckboxOption[] = [
  { value: 'CLEANING', label: 'Cleaning' },
  { value: 'ERRANDS', label: 'Errands' },
  { value: 'MAINTENANCE', label: 'Maintenance' },
];

export const HOUSEKEEPING_SERVICES_EXPERIENCE_OPTIONS: CheckboxOption[] = [
  { value: 'GENERAL_CLEANING', label: 'General Cleaning' },
  { value: 'SPECIALIZED_CLEANING', label: 'Specialized Cleaning' },
  { value: 'PREPARE_SNACKS_MEALS', label: 'Prepare Snacks/Meals' },
  { value: 'WASH_DISHES', label: 'Wash Dishes' },
  { value: 'DO_LAUNDRY', label: 'Do Laundry' },
  { value: 'RUN_ERRANDS', label: 'Run Errands' },
  { value: 'GENERAL_MAINTENANCE', label: 'General Maintenance' },
  { value: 'ORGANIZATION', label: 'Organization' },
];

// ---------------------------------------------------------------------------
// Pet care
// ---------------------------------------------------------------------------
export const PET_CARE_SERVICES_EXPERIENCE_OPTIONS: any = Object.values(PetCareExperienceOptions).map((experience) => ({
  value: experience,
  label: experience
    .replace(/_/g, ' ')
    .toLowerCase()
    .replace(/^\w/, (c) => c.toUpperCase()),
}));

export const numberOfPetOptions = (): SelectOption[] => [
  { value: '1', display: 'One pet' },
  { value: '2', display: 'Two pets' },
  { value: '3', display: 'Three pets' },
  { value: '4', display: 'Four or more' },
];
